import React, { useState } from 'react';
import { MinusCircleIcon } from '../../../../static/icons/iconMinusCircle';
import { PlusCircleIcon } from '../../../../static/icons/iconPlusCircle';
import colors from '../../../../tailwind.colors';
import { Row } from '../row/Row';
import { Typography } from '../typography/Typography';
import { Stack } from '../stack/Stack';
import { cnMerge } from '../../../utils/utils';

const SystemguideAnswerAccordion = ({
  text,
  textsHelp,
  textClassName,
  description,
  darkMode,
  textAlign = 'left',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex justify-center flex-col">
      <Row className="justify-start">
        <Stack className="gap-0">
          <Typography
            fontVariant="md"
            textAlign={textAlign}
            className={cnMerge(
              `${
                darkMode ? '!text-customGray-300' : '!text-customGray-900'
              } whitespace-normal text-ellipsis overflow-hidden font-light`,
              textClassName
            )}
          >
            {text}
          </Typography>

          {description && (
            <Typography
              fontVariant="xs"
              textAlign={textAlign}
              className={`leading-tight ${
                darkMode ? '!text-white' : '!text-customGray-900'
              } text-ellipsis overflow-hidden`}
            >
              {description}
            </Typography>
          )}
        </Stack>

        {textsHelp && (
          <div className="cursor-pointer mr-2">
            {isOpen ? (
              <MinusCircleIcon
                color={darkMode ? 'white' : colors.primary[700]}
                iconSize={22}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(false);
                }}
              />
            ) : (
              <PlusCircleIcon
                color={darkMode ? 'white' : colors.primary[700]}
                iconSize={22}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen((prev) => !prev);
                }}
              />
            )}
          </div>
        )}
      </Row>
      <div
        className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
          isOpen ? 'max-h-[1000px]' : 'max-h-0'
        }`}
      >
        <Stack className="flex gap-0">
          <Typography
            fontVariant="md"
            textAlign={textAlign}
            className="!text-customGray-500"
          >
            {textsHelp}
          </Typography>
        </Stack>
      </div>
    </div>
  );
};

export default SystemguideAnswerAccordion;
